<template>
  <FindInfoSlot>
    <template #findinfo-container>
      <img
        class="findinfo-complete-icon"
        src="/media/images/icon/changepassword-complete-icon.png"
        alt="changepassword-complete-icon.png"
      />
      <h1 class="findidv2-title">비밀번호 변경 완료</h1>
      <p class="findidv2-desc lh15">
        비밀번호가 변경되었습니다. <br />
        다시 로그인해주세요.
      </p>
      <div class="changepassfinishedv2-wrap ">
        <BasicButton @click-btn="goLogin()">
          <template #btnname>
            로그인하기
          </template>
        </BasicButton>
      </div>
    </template>
  </FindInfoSlot>
</template>
<script>
import FindInfoSlot from '@/slot/findInfoSlot.vue';
import BasicButton from '@/components/BasicButton/BasicButton.vue';
import router from '@/router';
export default {
  components: {
    FindInfoSlot,
    BasicButton
  },
  methods: {
    goLogin() {
      router.replace('/login');
    }
  }
};
</script>
<style scoped src="@/assets/css/changepassfinishedv2/changepassfinishedv2.css"></style>
